import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import './Modal.scss';
import ModalProps from '../../../types/Modal.types';

const ConfirmUpdateModal: React.FC<ModalProps> = ({ open, handleClose, handleConfirmUpdate }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box className="modal">
        <Typography id="modal-title" variant="h6" component="h2">
          Confirm Update
        </Typography>
        <Typography id="modal-description" sx={{ mt: 2 }}>
          Are you sure you want to update the dispatcher notes?
        </Typography>
        <Button onClick={handleConfirmUpdate} variant="contained" color="primary" sx={{ mt: 2 }}>
          Yes
        </Button>
        <Button onClick={handleClose} variant="outlined" color="secondary" sx={{ mt: 2, ml: 2 }}>
          No
        </Button>
      </Box>
    </Modal>
  );
};

export default ConfirmUpdateModal;